import { Card, CardBody, CardHeader } from "@/components/ui/Card";
import { CardTitleWithHelp } from "@/components/ui/title-help";

import { formatInspectionTimestamp } from "./clampQcInspectionTable";
import type { ClampQcCartonSessionRow } from "./clampQcCartonSessionRows";

const RECENT_FAILS_LIMIT = 12;

export function ClampQcRecentFailsCard({ rows }: { rows: readonly ClampQcCartonSessionRow[] }): JSX.Element {
  const visibleRows = rows.slice(0, RECENT_FAILS_LIMIT);

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitleWithHelp
          hoverHint="Failed units recorded during this browser session on this job. They are not packed into a carton and do not appear in the This carton list. Rescanning a serial and updating the QC check replaces its row here."
          className="text-base"
        >
          Recent fails this session ({rows.length})
        </CardTitleWithHelp>
      </CardHeader>
      <CardBody className="max-h-[240px] overflow-auto p-2">
        {visibleRows.length === 0 ? (
          <p className="rounded-md border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-center text-sm text-slate-600">
            No failed units recorded yet this session.
          </p>
        ) : (
          <div className="overflow-x-auto rounded-md border border-slate-200">
            <table className="min-w-[520px] w-full border-collapse text-left text-xs text-slate-800">
              <thead>
                <tr className="border-b border-slate-200 bg-slate-100 text-[11px] font-semibold uppercase tracking-wide text-slate-600">
                  <th className="whitespace-nowrap px-2 py-2">Date and time</th>
                  <th className="whitespace-nowrap px-2 py-2">Serial</th>
                  <th className="whitespace-nowrap px-2 py-2">Fail reason</th>
                </tr>
              </thead>
              <tbody>
                {visibleRows.map((row, index) => (
                  <tr
                    key={`${String(row.serial)}-${row.timestampIso}-${String(index)}`}
                    className="border-b border-slate-100 odd:bg-white even:bg-slate-50/80"
                  >
                    <td className="whitespace-nowrap px-2 py-1.5">{formatInspectionTimestamp(row.timestampIso)}</td>
                    <td className="whitespace-nowrap px-2 py-1.5 tabular-nums font-medium text-slate-900">
                      {row.serial}
                    </td>
                    <td className="max-w-[280px] break-words px-2 py-1.5 text-slate-600">
                      {row.failReason?.trim() ? row.failReason : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardBody>
    </Card>
  );
}
